//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
//import Button from 'react-bootstrap/Button';

///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from '../../../config/settings';
///////////////////////////////////////////////////////////   COMPS
import MainVideo from '../main-video/main-video.component';
import ProgramPanel from '../../shared/program-panel/program-panel.component';
import TvShowProgramPanel from '../tv-show-program-panel/tv-show-program-panel.component';
import VideoPlaylist from '../video-playlist/video-playlist.component';
import VideoDownloads from '../video-downloads/video-downloads.component';
import PhotoPanel from '../photo-panel/photo-panel.component';
import HelpPanel from '../help-panel/help-panel.component';
import LightTable from '../light-table-panel/light-table-panel.component';
import CommentPanel from '../comment-panel/comment-panel.component';
//import Theater from './theater-mode.component';
import { Scrollbars } from 'react-custom-scrollbars';
///////////////////////////////////////////////////////////   FONTAWESOME
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare, faCoffee, faPlayCircle, faTable, faList, faQuestionCircle, faCamera, faTheaterMasks, faWindowMaximize } from '@fortawesome/free-solid-svg-icons';

///////////////////////////////////////////////////////////   SCSS
import '../../../pages/videojs-player/videojs-video-player.styles.scss';
///////////////////////////////////////////////////////////   INTERFACE


interface programObject {
  [key: string]: any;
}
interface Event {
  ctrlKey: boolean;
}

declare global {
  interface Window { }
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class VideojsVideoPlayer extends React.Component<any, { [key: string]: any }> {

  private vxRef: React.RefObject<MainVideo>;
  constructor(props: any) {
    super(props);
    this.state = {
      ...this.props,
      cleanSrc: this.getCleanUrl(this.props.mainVideo),
      userConfig: null
    };
    this.vxRef = React.createRef();
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS

  componentDidUpdate(prevProps: any) {
    if (this.props !== prevProps) {
      this.setState({ ...this.props, cleanSrc: this.getCleanUrl(this.props.mainVideo) });
    }
    if (this.props.userConfig !== prevProps.userConfig) {
      this.setState({ userConfig: this.props.userConfig });
    }
  }
  componentDidMount() {
    document.addEventListener('wheel', (e) => this.disabelWheel(e), { passive: false });
  }
  componentWillUnmount() {
    document.removeEventListener('wheel', this.disabelWheel, true);
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   *  Get clean url
   * @param programData
   * @returns url
   */
  private getCleanUrl = (programData: programObject): string | null => {
    let url = null;
    if (programData && programData.program instanceof Array) {
      programData.program.forEach((v: any, k: number) => {
        if (v.id === 'url') {
          url = v.data.replace('#', '');
        }
      });
    }
    return url;
  };
  /**
   * Disable mouse wheel
   * Prevents scroll-zooming in page
   * @param e
   */
  private disabelWheel = (e: Event | any): void => {
    e.ctrlKey && e.preventDefault();
  };

  /**
   * Handle and load playlist video data
   * @param data: video related data
   */
  private handlePlaylist = (data: programObject): void => {
    this.setState({ mainVideo: data });
  };

  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { mainVideo, playerType, _played, _duration, _timeCode, _frameCode, snapshotDesignBg, showUniqueUrl, _preLoadingTime, outputRes } = this.state;
    const { sideNav, playList, _playListActivatedBtn, showPlaylist, userConfig, endPoint } = this.state;
    return (
      <Row>
        <MainVideo ref={this.vxRef} {...this.state} />
        {playerType !== _SETTINGS.playerType.embed ? (
          <Col lg={12} xl={4} md={12} className='right-content-holder'>
            <Scrollbars renderTrackHorizontal={(props) => <div {...props} className='track-horizontal' />} renderTrackVertical={(props) => <div {...props} className='track-vertical' />} renderThumbHorizontal={(props) => <div {...props} className='thumb-horizontal' />} renderThumbVertical={(props) => <div {...props} className='thumb-vertical' />} renderView={(props) => <div {...props} className='view' />} autoHeight autoHeightMin={100} autoHeightMax='calc(90vh)' autoHide>
              <Tabs id='uncontrolled-tab-example' className='rounded-0 mb-0 content-holder'>
                {sideNav && sideNav.program && mainVideo.program && mainVideo.program.length >= 1 ? (
                  <Tab
                    eventKey='felvetel'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon="table" />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.felvetel.name}</span>
                      </>
                    }
                  >
                    {mainVideo.linkButtons && mainVideo.linkButtons.length >= 1 ? <VideoDownloads mainVideo={mainVideo} /> : null}

                    <ProgramPanel programData={mainVideo} />
                  </Tab>
                ) : null}
                {sideNav && sideNav.tvShowProgram && mainVideo.tvShowProgram && mainVideo.tvShowProgram.length >= 1 ? (
                  <Tab
                    eventKey='musor'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon={_SETTINGS.sideMenu.musor.icon as IconProp} />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.musor.name} </span>
                      </>
                    }
                  >
                    <TvShowProgramPanel mainVideo={mainVideo} />
                  </Tab>
                ) : null}
                {sideNav && sideNav.playList && playList && playList.length ? (
                  <Tab
                    eventKey='playlist'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon={_SETTINGS.sideMenu.lista.icon as IconProp} />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.lista.name} </span>
                      </>
                    }
                  >
                    <VideoPlaylist mainVideo={mainVideo} played={_played} showUniqueUrl={showUniqueUrl} loadUniqueUrlExt={this.props.loadUniqueUrl} timeCode={_timeCode} frameCode={_frameCode} preLoadingTime={_preLoadingTime} duration={_duration} handlePlaylistExt={this.handlePlaylist} playList={playList} playListActivatedBtn={_playListActivatedBtn} showPlaylist={showPlaylist} />
                  </Tab>
                ) : null}
                {sideNav && sideNav.snapshot ? (
                  <Tab
                    eventKey='generateThumbnails'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon={_SETTINGS.sideMenu.kep.icon as IconProp} />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.kep.name}</span>
                      </>
                    }
                  >
                    <PhotoPanel vxRef={this.vxRef} snapshotDesignBg={snapshotDesignBg} outputRes={outputRes} mainVideo={mainVideo} />
                  </Tab>
                ) : null}
                {sideNav && sideNav.lightTable && (
                  <Tab
                    eventKey='lightTable'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon={_SETTINGS.sideMenu.lightTable.icon as IconProp} />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.lightTable.name} </span>
                      </>
                    }
                  >
                    {
                      // TODO:: remove one of the players below..
                      //console.log('mainVideo', mainVideo.program)
                    }
                    <LightTable {...mainVideo} {...mainVideo?.preview} vxRef={this.vxRef} player={this.vxRef} />
                  </Tab>
                )}

                {sideNav && sideNav.comment && (
                  <Tab
                    eventKey='comment'
                    title={
                      <>
                        <span className='tab_icon'>
                          <FontAwesomeIcon icon={_SETTINGS.sideMenu.comment.icon as IconProp} />
                        </span>
                        <span className='tab-text'>{_SETTINGS.sideMenu.comment.name} </span>
                      </>
                    }
                  >
                    <CommentPanel userConfig={userConfig} mainVideo={mainVideo} endPoint={endPoint} />
                  </Tab>
                )}

                {sideNav && sideNav.help ? (
                  <Tab
                    eventKey='help'
                    title={
                      <span className='tab_icon'>
                        <FontAwesomeIcon icon={_SETTINGS.sideMenu.help.icon as IconProp} />
                      </span>
                    }
                  >
                    <HelpPanel />
                  </Tab>
                ) : null}
              </Tabs>
            </Scrollbars>
          </Col>
        ) : null}
      </Row>
    );
  }
}

export default VideojsVideoPlayer;
